// extracted by mini-css-extract-plugin
export default {"wrapper":"Yp","subscription":"Zp","select_item":"aq","is_selected":"bq","otb":"cq","radio":"eq","first_row":"fq","prices":"gq","italic":"hq","info_wrapper":"iq","first_month":"jq","separator":"kq","checkmark":"lq","bullets":"mq","bullet":"nq","checkmarkText":"oq","button":"pq","discountBadge":"qq"};
    if(module.hot) {
      // 1715276855651
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  